export default function HeadlineBlock({ lines, accent, sub }) {
  return (
    <div className="su-headline">
      <h2 className="su-title">
        {lines}
        {accent ? <span className="su-title-accent">{accent}</span> : null}
      </h2>
      {sub ? <p className="su-subtitle">{sub}</p> : null}
    </div>
  );
}
